<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><span aria-label="ii" class="page" id="pii" role="doc-pagebreak"></span><span aria-label="iii" class="page" id="piii" role="doc-pagebreak"></span>REASON &amp; CHARACTER</h1>
<h1 class="bk1">The Moral Foundations of Aristotelian Political Philosophy</h1>
<h1 class="bk2">◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉</h1>
<p class="bkau">LORRAINE SMITH PANGLE</p>
<h1 class="bk2">◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉ ◉</h1>
<p class="bkpub">The University of Chicago Press</p>
<p class="bkpub1">CHICAGO AND LONDON</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-pangle-reason-0003.vue?1396451e